<template>
    <section class="text-center">
        <time class="text-7xl font-extralight text-gray-800 tabular-nums">
            {{ currentTime }}
        </time>
        <p class="text-gray-500 mt-3 font-medium tracking-wide">
            {{ currentDate }} <span class="mx-1">·</span> {{ chineseLunar }}
        </p>
    </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const currentTime = ref('00:00');
const currentDate = ref('1月 1 周一');
const chineseLunar = ref('');

const updateTime = () => {
    const now = new Date();
    currentTime.value = now.toLocaleTimeString('zh-CN', { hour12: false, hour: '2-digit', minute: '2-digit' });
};

const updateDate = () => {
    const now = new Date();
    currentDate.value = now.toLocaleDateString('zh-CN', { month: 'long', day: 'numeric', weekday: 'short' });

    // 原生农历逻辑
    try {
        const formatter = new Intl.DateTimeFormat('zh-u-ca-chinese', {
            year: 'numeric', month: 'numeric', day: 'numeric',
        });
        const parts = formatter.format(now); // 得到类似 "2026丙戌年2月14"

        // 提取数字月日并转换
        const rawMonthDay = parts.split('年')[1] || ''; // "2月14"
        chineseLunar.value = formatToChineseLunar(rawMonthDay);
    } catch (e) {
        console.error("农历解析失败", e);
    }
}

// 辅助函数：将数字月日转为全中文农历格式
const formatToChineseLunar = (rawStr) => {
    const cnNums = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];

    // 1. 提取月份部分
    const monthPart = rawStr.match(/.*?(?=月)/)?.[0] || ''; // 提取“月”之前的内容
    // 2. 提取日期部分
    const dayPart = rawStr.match(/\d+/g)?.pop() || rawStr.match(/[一二三四五六七八九十廿]+/g)?.pop() || '';

    // --- 月份修正逻辑 ---
    let mStr = monthPart;
    // 如果是数字，转为中文称呼
    if (!isNaN(parseInt(monthPart))) {
        const mNum = parseInt(monthPart);
        const monthNames = ["正月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "冬月", "腊月"];
        mStr = monthNames[mNum - 1] || monthPart;
    } else {
        // 如果已经是中文，修正特殊月份
        if (mStr === '一') mStr = '正月';
        if (mStr === '十一') mStr = '冬月';
        if (mStr === '十二') mStr = '腊月';
        if (!mStr.endsWith('月')) mStr += '月'; // 确保补全“月”字
    }

    // --- 日期转换逻辑 ---
    let dStr = "";
    const dNum = parseInt(dayPart);

    if (!isNaN(dNum)) {
        // 如果日期是数字 (例如 14)
        if (dNum <= 10) dStr = "初" + cnNums[dNum];
        else if (dNum < 20) dStr = "十" + cnNums[dNum % 10];
        else if (dNum === 20) dStr = "二十";
        else if (dNum < 30) dStr = "廿" + cnNums[dNum % 10];
        else if (dNum === 30) dStr = "三十";
    } else {
        // 如果日期已经是中文 (例如 十四)，直接使用
        dStr = dayPart;
        // 特殊情况：如果中文日期是 "一" 到 "十"，补个 "初"
        const simpleDays = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
        if (simpleDays.includes(dStr)) dStr = '初' + dStr;
    }

    return mStr + dStr;
};

const isPageActive = ref(true);

const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
        isPageActive.value = true;
        console.log("欢迎回来：页面进入前台显示状态");
        clearInterval(timer);
        timer = setInterval(updateTime, 1000);
        
    } else {
        isPageActive.value = false;
        console.log("离开提醒：页面已切到后台");
        clearInterval(timer);
    }
};

let timer;
onMounted(() => {
    updateTime();
    updateDate();
    timer = setInterval(updateTime, 1000);
    document.addEventListener('visibilitychange', handleVisibilityChange)
});

onUnmounted(() => {
    clearInterval(timer);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
});

</script>